var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8715 0.585787C10.4964 0.210714 9.98772 0 9.45729 0H2C0.895431 0 0 0.895429 0 2V17.4286C0 18.5331 0.895431 19.4286 2 19.4286H14C15.1046 19.4286 16 18.5331 16 17.4286V6.54271C16 6.01228 15.7893 5.50357 15.4142 5.1285L10.8715 0.585787Z",
    fill: "#5D68B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3339 10.5L10.7464 9.85379L8.41724 12.4113V6.83337H7.5839V12.4113L5.2589 9.84921L4.66724 10.5L8.00057 14.1667L11.3339 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.29ea654276f6060959e3a4988c055b0f.svg";
export { ForwardRef as ReactComponent };